import { Component, Input, OnInit } from '@angular/core';
import { MixedLoyaltyItemType, ProcessProviderId, RewardsWalletItem } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
})
export class WalletPageComponent implements OnInit {
  @Input() walletItems: RewardsWalletItem[];
  @Input() marketplaceFilterTypes: ProcessProviderId[] = [0, 1, 2, 3, 4, 5];
  @Input() itemTypes: MixedLoyaltyItemType[] = [MixedLoyaltyItemType.All];
  isList: boolean = true;
  walletItemsUnclaimed$: Observable<RewardsWalletItem[]>;

  constructor() {}

  ngOnInit() {}
}
